// import { NavigatorService } from './../statemanagement/navigator.service';
import { LineComponent } from './../line.component';
import { TermsAndConditionService } from '../services/terms-and-condition.service';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LineStateActionService } from '../statemanagement/line-state-action.service';
import { ModalService } from 'src/app/shared/service/modal/modal.service';
import { SetChannelAction } from '../statemanagement/action/channel.action';
import { Channel } from '../models/channel.model';
import { ActionStatus, ResponseStatus, TermsAndCondition } from "../models/termAndCondition.model";
import { Observable } from 'rxjs-compat';
// import { Observable,forkJoin } from 'rxjs';
@Component({
    selector: 'app-term-and-condition',
    templateUrl: './term-and-condition.component.html',
    styleUrls: ['./term-and-condition.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class TermAndConditionComponent implements OnInit {
    params: any = {};
    comCode: string;
    showTerm: boolean;
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private lineStateAction: LineStateActionService,
        private termsAndConditionService: TermsAndConditionService,
        // private navigatorService: NavigatorService,
    ) { }

    ngOnInit() {
        Observable.forkJoin(this.lineStateAction.observableChannel);
        const channel = this.lineStateAction.channelStateInfo;
        this.comCode = channel ? channel.comCode : '';
        console.log(['terms-and-cond: ', channel]);
        const session_ref = new Date().valueOf()
        let requestBody = {
            ...channel,
            "terms_and_condition_flag": false,
            "lead_reference_number":channel.refCode,
            "session_ref": session_ref
        }
        const forceOpen = this.route.snapshot.queryParams["force"];
        if(forceOpen){
            requestBody = {
                ...requestBody,
                // "channel_identity": "forceOpen",
                "terms_and_condition_flag": true,
                "lead_reference_number":""
            }
        }
        this.termsAndConditionService.apiCheckTermsAndCondition(requestBody).subscribe(
            result => {
                if (result && result.response_code == "40000") {
                    if (result.payload.token_url) {
                        // const identity = this.lineStateAction.identityStateInfo;
                        // const customer = this.lineStateAction.customerStateInfo;
                        // sessionStorage.setItem(session_ref + "channel", JSON.stringify(channel));
                        // sessionStorage.setItem(session_ref + "identity", JSON.stringify(identity));
                        // sessionStorage.setItem(session_ref + "customer", JSON.stringify(customer));
                        this.setSessionStorage(session_ref);
                        window.location.href = result.payload.token_url;
                    } else {
                        channel.termsAndCondition = {
                            status:"skip"
                        } as TermsAndCondition
                        this.lineStateAction.sinkChannel.next(new SetChannelAction(channel));
                        this.router.navigate([`/register/line/${this.comCode}`], { relativeTo: this.route, queryParams: { "termsandcondition": "skip" } })
                        // this.router.navigate([`../verifyRegister`], { relativeTo: this.route, queryParams: { "termsandcondition": "skip" } })
                    }
                } else {
                    console.log('check terms and condition out of case')
                    channel.termsAndCondition = {
                        status:"fail"
                    } as TermsAndCondition
                    this.lineStateAction.sinkChannel.next(new SetChannelAction(channel));
                    this.router.navigate([`/register/line/${this.comCode}/completed`], { relativeTo: this.route, queryParams: { "status": "fail" } })
                }
                console.log('check terms and condition result: ',result)
            },
            error => {
                channel.termsAndCondition = {
                    status:"fail"
                } as TermsAndCondition
                this.lineStateAction.sinkChannel.next(new SetChannelAction(channel));
                console.log('check terms and condition error')
                this.router.navigate([`/register/line/${this.comCode}/completed`], { relativeTo: this.route, queryParams: { "status": "fail","code":"termsAndCondition error" } })
            }
        );


        // this.modalService.open()
        // if (channel && channel.comCode == 'insure') {
        //     this.showTerm = false;
        //     this.router.navigate(['../application-form'], { relativeTo: this.route, queryParams: this.params });
        // } else {
        //     // this.termsAndCondService.apiCheckTermsAndCond()
        //     this.showTerm = true;
        // }
    }

    setSessionStorage(sessionRef){
        const channel = this.lineStateAction.channelStateInfo;
        const identity = this.lineStateAction.identityStateInfo;
        const customer = this.lineStateAction.customerStateInfo;
        let json = {
            "channel":channel,
            "identity":identity,
            "customer":customer,
        }
        sessionStorage.setItem(sessionRef, JSON.stringify(json));
    }

    // onSubmit() {
    //     console.log(this.params);
    //     this.navigatorService.setNavigate("term-and-condition", false)
    //     this.router.navigate([`../navigator`], { relativeTo: this.route });
    //     // this.router.navigate(['confirm-otp'], { relativeTo: this.route, queryParams: { params: query } });
    // }
}
